<template>
  <div class="sheji" style="padding-top: 50px;">
    <img src="../../static/image/ui_title.png" class="fullWidth" />
    <div style="height: 100px;"></div>
    <div class="ui-title">设计理念</div>
    <div style="height: 100px;"></div>
    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="16">
        <Row>
          <Col span="6" v-for="(item,index) in shejiList" :key="index">
            <div>
              <img :src="item.icon" style="width: 50%" class="centerLR" />
            </div>
            <div class="font24 color33 alignCenter" style="padding-top: 20px;">{{item.name}}</div>
            <div class="font14 color99" style="padding:  15px;">{{item.subname}}</div>
          </Col>
        </Row>
      </Col>
    </Row>
    <div style="height: 100px;"></div>
    <div class="ui-title">设计流程</div>
    <div style="height: 50px;"></div>
    <Row>
      <Col span="12" offset="6">
        <div class="font14 color99">
          拿到一个项目，我们先从客户的用户、产品、品牌入手，建立一套有效的策略，根据策略计划进行用户研究，
          再根据用研结果定义有效的信息架构和交互流程，得到客户及用户的认定后我们就开始大量的细致入微的视觉设计工作，
          随着视觉设计的完成，设计师开始协同开发人员调试完成的功能页面，测试人员开始测试手机产品使用报告，以确保产品的高效率、高质量
        </div>
      </Col>
    </Row>
    <div style="height: 100px;"></div>
    <Row type="flex" justify="center" class="code-row-bg">
      <Col span="14">
        <table class="fullWidth">
          <tr>
            <td width="50%">
              <img src="../../static/image/ui_zhongjian.png" class="fullWidth" />
            </td>
            <td style="padding-left: 100px;">
              <div class="ui-zhong-title">1.需求分析及信息架构梳理</div>
              <div class="ui-zhong-subtitle">产品需求分析、产品信息架构梳理</div>
              <div class="ui-zhong-title">2.产品体验概念设计</div>
              <div class="ui-zhong-subtitle">概念创新探索、交互框架设计、视觉风格设计</div>
              <div class="ui-zhong-title">3.产品交互及视觉体验设计</div>
              <div class="ui-zhong-subtitle">具体原型交互设计、具体视觉界面设计</div>
              <div class="ui-zhong-title">4.相关设计规范文档建立</div>
              <div class="ui-zhong-subtitle">交互体验设计规范制定、视觉体验规范制定</div>
              <div class="ui-zhong-title">5.UED流程的建立及培训</div>
              <div class="ui-zhong-subtitle">UED流程体系建立、用户体验基础培训</div>
            </td>
          </tr>
        </table>
      </Col>
    </Row>
    <div style="height: 50px;"></div>
    <div class="fontfaYahei font24 alignCenter color33">遵循每一个细节就是我们前进的明灯</div>
    <div style="height: 100px;"></div>
    <xfck></xfck>
  </div>
</template>

<script>
import xfck from "./xfck.vue";
var img_url_i = "";
// if (window.location.host.slice(0, 5) === "local") {
//   img_url_i = "..";
// } else {
//   img_url_i = "/jianyunPC";
// }
export default {
  name: "sheji",
  data() {
    return {
      shejiList: [
        {
          name: "策略研究",
          icon: img_url_i + "/static/image/celueyanjiu.png",
          subname:
            "我们洞察市场需求及用户痛点，为企业简历切实可行的互联网产品策略。"
        },
        {
          name: "用户体验",
          icon: img_url_i + "/static/image/yonghutiyan.png",
          subname:
            "综合运用现场观察、深入访谈、焦点小组等方法，来获得用户需求及产品使用偏好。"
        },
        {
          name: "交互设计",
          icon: img_url_i + "/static/image/jiaohusheji.png",
          subname:
            "基于用户研究分析、建立符合用户使用场景和用户真正需求的交互模型。"
        },
        {
          name: "视觉设计",
          icon: img_url_i + "/static/image/shijuesheji.png",
          subname: "打造搞品质专属笨企业的产品视觉设计，让用户第一眼就喜欢上。"
        }
      ]
    };
  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sheji.vue